import Collapse from '@material-ui/core/Collapse';
import { InfoIcon, Translation } from '@ps/web-shared-components';
import { minLength, mustContainNumber, noWhiteStartOrEnd } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React, { useState } from 'react';

import ArrowIcon from '@swf/core/assets/icons/arrow.svg';
import LockIcon from '@swf/core/assets/icons/lock.svg';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import TextInput from '../../../TextInput/TextInput';

import {
  TXTCLI_We_encrypt_your_data_so_itXs_s_ELL,
  TXTCLI_WhatXs_your_SSNX,
  TXTCLI_Your_SSN,
  TXTMOB_Please_enter_the_last_4_digits_ELL,
  TXTWCL_How_is_my_data_kept_safeX,
  TXTWCL_SSN,
  TXTWCL_We_keep_your_data_safe
} from './RMFSSN.messages.json';
import {
  active,
  arrow,
  arrowContainer,
  infoBox,
  infoText,
  subtitle,
  subtitleText
} from './RMFSSN.scss';

const RMFSSN: React.FC = () => {
  const [infoExpanded, setInfoExpanded] = useState<boolean>(false);
  return (
    <Container
      page={RMFSSN}
      headerProps={{
        title: <Translation {...TXTCLI_Your_SSN} />
      }}
      pageTopTitle={<Translation {...TXTCLI_WhatXs_your_SSNX} />}
      pageTopSubtitle={
        <div className={subtitle}>
          <LockIcon />
          <div className={subtitleText}>
            <Translation {...TXTWCL_We_keep_your_data_safe} />
          </div>
        </div>
      }
    >
      <TextInput
        id="nationalDocumentNumber"
        label={TXTWCL_SSN}
        validators={[
          noWhiteStartOrEnd,
          mustContainNumber(TXTMOB_Please_enter_the_last_4_digits_ELL),
          minLength(4, TXTMOB_Please_enter_the_last_4_digits_ELL)
        ]}
        maxLength={4}
        placeholder="0000"
        helperMessage={<Translation {...TXTMOB_Please_enter_the_last_4_digits_ELL} />}
      />
      <div className={infoBox} onClick={() => setInfoExpanded(!infoExpanded)}>
        <InfoIcon />
        <div className={infoText}>
          <Translation {...TXTWCL_How_is_my_data_kept_safeX} />
        </div>
        <div className={arrowContainer}>
          <ArrowIcon className={classNames(arrow, { [active]: infoExpanded })} />
        </div>
      </div>
      <Collapse in={infoExpanded}>
        <Translation {...TXTCLI_We_encrypt_your_data_so_itXs_s_ELL} />
      </Collapse>
      <CTAButton />
    </Container>
  );
};

RMFSSN.displayName = 'RMFSSN';

export default RMFSSN;
